export default "__VITE_ASSET__CDjnvU04__"